import { Component, OnInit, HostListener } from '@angular/core';
import { I18nService } from '@app/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router } from '@angular/router';
import { AuthService } from '@app/auth.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { timer } from 'rxjs/observable/timer'
import { TranslateService } from '@ngx-translate/core';
import { NotiService } from '@app/noti.service';

declare var $: any;
declare var OAuth: any
declare var gapi: any
declare var FB: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  error: string;
  isLoading = false;
  member_obj: any;
  obj_data_all: any;
  url: any;
  ip_add: any;
  ContactDros: any;

  form: FormGroup
  submitted = false

  returnUrl = ""

  isCompany = false

  cookieData: any
  isCrisis = true

  showLoginForm = true
  showQRForm = false
  showOtp = false

  telephoneOtp = ""
  otp = ""
  otpRef = ""
  requestOtpLbl = "ขอรหัส OTP"
  requestOtpLblTmp = "ขอรหัส OTP"
  otpTimer: any = ""

  PortalLogin: any

  dpa_portal: any = {}
  lastReqTime: any
  disableResentOtp = false
  totolWaitResend = 59

  ElapseTime: number = 0;
  TotalTime: number = 0;
  OTPCountDown: string = "";
  SubScr: Subscription;

  
  menuList: any
  regisMenu: any = {}

  lang = "th"

  menuEnabled = false

  
  private notiSubscription: Subscription;

  get formControl() {
    return this.form.controls;
  }

  constructor(private Auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private i18nService: I18nService,
    private util: UtilService,
    private apiService: ApiService,
    private fb: FormBuilder,
    private notiService: NotiService,
    private translate: TranslateService) {

    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      ip: ""
    });

    router.events.subscribe((val) => {
      // see also
      if (val instanceof NavigationEnd) {
        console.log(val.url);
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key == "Enter") {
      this.Login();
    }
  }

  ngOnDestroy() {
    if(this.notiSubscription){
      this.notiSubscription.unsubscribe();
    }
  }

  async ngOnInit() {
    this.util.ShowWaiting(true);

    this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    if(this.cookieData == null){
      this.cookieData = {}
    }

    let config: any = await this.apiService.get("master", "configuration")
    let crisisConfig: any = config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
      this.cookieData.isCrisis = true
      this.isCrisis = true
      localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))
      $(".btn-social-login").addClass("sr-only")
    }
    else {
      this.cookieData.isCrisis = false
      this.isCrisis = false
      $(".btn-social-login").removeClass("sr-only")
      localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))
    }


    let menuList:any = await this.apiService.get("master", "customerPortalMenuSetting")
    let thisMenu: any = this.util.getMenuObj(menuList, "04", this.isCrisis)
    let regisMenu: any = this.util.getMenuObj(menuList, "11", this.isCrisis)
    if(!thisMenu.show && !regisMenu.show){
      this.util.ShowWaiting(false)
      setTimeout(() => {
        this.router.navigate(["mainmenu/index"])
      }, 500);
      return
    }
    else {
      this.menuEnabled = true
    }
    // let tmpLang = this.util.GetCurrentLang()
    // this.lang = tmpLang.substring(0,2)
    // this.util.SetLanguage(tmpLang)

    this.notiSubscription = this.notiService.message.subscribe(_lang => {
      this.lang = _lang
      this.swithLbl()
    });

    await this.util.getIPAddress().subscribe((res: any) => {
      this.form.controls["ip"].setValue(res.json().ip)
    })

    this.route.queryParams.subscribe((params: Params) => {
      if (params != null && params['error'] == null && params['code'] != null) {
        this.getLineProfile(params)
      }
      else {
        this.util.ShowWaiting(false);
      }
    });

    
    this.menuList = await this.apiService.get("master", "customerPortalMenuSetting")
    this.regisMenu = this.getMenuObj("11")

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];

    this.fbLibrary();
  }

  async showAgreementDialog(){
    //$('#agreementDialog').modal({
    //  backdrop: 'static',
    //  keyboard: false
    //});

    this.router.navigate(["singlegatewaywait3"]);

  }

  swithLbl(){
    if(this.requestOtpLblTmp == "ขอรหัส OTP"){
      let lblTmp: any = this.translate.get("RequestOTP")
      this.requestOtpLbl = lblTmp.value
    }
    else{
      let lblTmp: any = this.translate.get("ResendOTP")
      this.requestOtpLbl = lblTmp.value
    }
  }

  btnAgreement(){
    this.showLoginForm = false
    this.showQRForm = true

    if (this.showQRForm) {
      setTimeout(() => {
        let thisTs = this;
        this.util.WarningDialog("หมดเวลาแสดง QR Code <br> กรุณาเข้าหน้า login ใหม่อีกครั้ง");
        this.showQRForm = false
        $("#btnWarningOK").click(function () {
          thisTs.router.navigate(["/mainmenu/index"]);
        });
        //this.router.navigate(["mainmenu/index"])
      }, 30000);
      return
    }
  }

  async Login() {
    try {
      this.submitted = true
      if (this.form.valid) {
        this.util.ShowWaiting(true)
        localStorage.removeItem("oneOTP");
        let res: any = await this.apiService.postCustomApi("User", "Login", this.form.value)
        this.util.ShowWaiting(false)
        //if (this.util.isSuccessResponse(res)) {
          if (res != null && res.customerid != null && res.customerid != "") {

            this.dpa_portal = {
              firstname: res.firstname,
              lastname: res.lastname,
              email: res.username,
              contactid: res.customerid,
              pid: res.pid,
              readNewsList: res.readNewsList
            }

            let contact: any = await this.apiService.get("crmservice", "contact", "contactid=" + res.customerid)
             contact = contact[0]
            if(this.isCrisis)
            {
              if (contact.dpa_companytypeid != null && contact.dpa_companytypeid.trim().length > 0)
              {
                this.ContactDros = await this.getContactDROS(contact.dpa_registrationid)
              }    
              else if (contact.dpa_passport != null && contact.dpa_passport.trim().length > 0)
              {
                this.ContactDros = await this.getContactDROS(contact.dpa_passport)
              }
              else
              {
                this.ContactDros = await this.getContactDROS(contact.dpa_idcard)
              }  
              if (!this.util.IsNullOrUndefined(this.ContactDros.CRM06)) {
                if(!this.util.IsNullOrUndefined(this.ContactDros.CRM06.AccountStatus) && this.ContactDros.CRM06.AccountStatus == '2')
                { 
                  let thisTs = this;
                  this.util.WarningDialog("กรุณาติดต่อ DPA Call Center 1158");
                  $("#btnWarningOK").click(function () {
                    thisTs.router.navigate(["/mainmenu/index"]);
                  });
                  //thisTs.router.navigate(["mainmenu/index"])
                  return;
                }

                //if(!this.util.IsNullOrUndefined(this.ContactDros.CRM06.AccountStatus) && this.ContactDros.CRM06.AccountStatus == '3')
                  //{ 
                    //let thisTs = this;
                    //this.util.WarningDialog("กรุณาติดต่อ DPA Call Center 1158");
                    //$("#btnWarningOK").click(function () {
                    //  thisTs.router.navigate(["/mainmenu/index"]);
                    //});
                    ////thisTs.router.navigate(["mainmenu/index"])
                    //return;
                  //}
              }

            }

            this.util.ShowWaiting(false)

            if (contact != null && contact.length > 0) {
              this.telephoneOtp = contact[0].telephone1
            }

            this.cookieData = this.dpa_portal
            localStorage.setItem("dpa_portal", JSON.stringify(this.dpa_portal))
  
            let ticket: any = await this.apiService.get("crmservice", "searchApprovalTicket", "contactid=" + this.cookieData.contactid)
            this.util.ShowWaiting(false)
  
            if (ticket != null && ticket.length > 0 && (ticket[0].dpa_approvalstatuscode == "01" || ticket[0].dpa_approvalstatuscode == "02" || ticket[0].dpa_approvalstatuscode == "06")) {
              let url = this.util.baseUrl() + "/mainmenu/statusDocument/" + this.cookieData.contactid
              window.open(url, "_blank")
              this.showLoginForm = false
              this.showOtp = true
            }
            else{this.router.navigate(["mainmenu/refundDeposits"])}
            
            //let thisTs = this

            //thisTs.router.navigate(["/mainmenu/refundDeposits"]);
            //this.showLoginForm = false
            //this.showOtp = true
          }
          else {
            if (res != null && res.islock != null && res.islock) {
              let thisTs = this
              if(res.lockmin != null)
              { 
                
                this.util.ErrorDialog("กรุณารอสักครู่ ท่านได้ทำรายการเกินจำนวนครั้งที่กำหนด ท่านจะสามารถดำเนินการใหม่ได้หลังจากครบ " + res.lockmin + " นาที") 
              }
              else{
                this.util.ErrorDialog("กรุณารอสักครู่ ท่านได้ทำรายการเกินจำนวนครั้งที่กำหนด") }
              $("#btnMainError").off("click");
              $("#btnMainError").click(function () {
                thisTs.router.navigate(["/mainmenu/index"]);
              });
            }
            else{
              this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง ท่านสามารถลองใหม่ได้รวมทั้งหมดไม่เกิน 3 ครั้ง")
            }
          }
        //}
        //else {
          //this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง")
        //}
      }
    } catch (ex) {
      this.util.ShowWaiting(false);
      console.log(ex)
      this.util.ErrorDialog('เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่');
    }
  }

  async CheckSession() {
    var str = '';
    $('#divData').html(str);
    var data = {}
    data['member_no'] = $('#txtUserName').val();
    var res: any = await this.apiService.postnotauthen('account', 'GetUserSession', data);
    this.util.ShowWaiting(false); 
    var check = 0;
    if (res.isSuccess) {
      if (res.responseData != null) {
        if (res.responseData.length > 0) {
          check++;
          this.ip_add = res.responseData[0].ip_address;
        }
      }
    }
    if (check == 0) {
      var res2: any = await this.apiService.postnotauthen('account', 'InsertUserSession', data);
      this.VisitApp(this.url);
    } else {
      this.util.ErrorDialog("user นี้ถูกใช้งานอยู่ (ip:" + this.ip_add + ")");
    }
  }

  VisitApp(url: any) {
    // window.location.href = url; 
    this.router.navigate([url]);
  }


  setLanguage(language: string) {
    this.i18nService.language = language;
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  ForgetPassword() {
    $('#txtMemberNo').val($('#txtUserName').val());
    $('#txtOldPassword').val('');
    $('#txtNewPassword').val('');
    $('#txtConfirmNewPassword').val('');
    $('#lblError').html('');
    $('#lblSuccess').html('');
    $('#dlgForgetPassword').modal({ backdrop: 'static', keyboard: false });
  }

  async SavePassword() {
    if ($('#txtMemberNo').val() != null && $('#txtMemberNo').val() != '') {

      if ($('#txtOldPassword').val() != null && $('#txtOldPassword').val() != '') {
        if ($('#txtNewPassword').val() != null && $('#txtNewPassword').val() != '') {
          if ($('#txtConfirmNewPassword').val() != null && $('#txtConfirmNewPassword').val() != '') {

            if ($('#txtNewPassword').val() == $('#txtConfirmNewPassword').val()) {

              this.util.ShowWaiting(true);
              var data = {};
              data["member_no"] = $('#txtMemberNo').val();
              data["old_password"] = $('#txtOldPassword').val();
              data["new_password"] = $('#txtNewPassword').val();
              var res: any = await this.apiService.postnotauthen('member', 'UpdatePassword', data);
              this.util.ShowWaiting(false);
              if (res != null) {
                if (res.isSuccess) {

                  // $('#dlgForgetPassword').modal('hide');
                  //  this.util.SuccessDialog('บันทึกสำเร็จ');
                  $('#lblError').html('');
                  $('#lblSuccess').html('บันทึกสำเร็จ:' + res.errorMessage);
                } else {
                  $('#lblError').html(res.errorCode + '-' + res.errorMessage);
                }
              } else {
                $('#lblError').html('System Error');
              }
            } else {
              $('#lblError').html('รหัสผ่านใหม่ไม่ตรงกัน');
            }
          } else {
            $('#lblError').html('กรุณากรอกค่าให้ครบถ้วน');
            $('#txtConfirmNewPassword').focus();
          }
        } else {
          $('#lblError').html('กรุณากรอกค่าให้ครบถ้วน');
          $('#txtNewPassword').focus();
        }
      } else {
        $('#lblError').html('กรุณากรอกค่าให้ครบถ้วน');
        $('#txtOldPassword').focus();
      }
    } else {
      $('#lblError').html('กรุณากรอกค่าให้ครบถ้วน');
      $('#txtMemberNo').focus();
    }
  }

  clear() {
    this.form.controls["username"].setValue("")
    this.form.controls["password"].setValue("")
    this.submitted = false
  }

  forgetPassword() {

  }

  onTypeChange(target: any) {
    if (target.checked) {
      this.isCompany = target.value == "c"
    }
  }

  fbLogin() {
    window['FB'].login((response: any) => { 
      if (response.authResponse) {

        window['FB'].api('/me', {
          fields: 'last_name, first_name, email'
        }, (userInfo: any) => {

          console.log("user information"); 
        });

      } else {
        console.log('User login failed');
      }
    }, { scope: 'email' });

    // // Initialize with your OAuth.io app public key
    // OAuth.initialize('HwAr2OtSxRgEEnO2-JnYjsuA3tc');
    // // Use popup for oauth
    // OAuth.popup('facebook').then((facebook: any) => {
    //   console.log('facebook:', facebook);
    //   // Prompts 'welcome' message with User's email on successful login
    //   // #me() is a convenient method to retrieve user data without requiring you
    //   // to know which OAuth provider url to call
    //   facebook.me().then((data: any) => {
    //     console.log('me data:', data);
    //     alert('Facebook says your email is:' + data.email + ".\nView browser 'Console Log' for more details");
    //   })
    //   // Retrieves user data from OAuth provider by using #get() and
    //   // OAuth provider url
    //   facebook.get('/v2.5/me?fields=name,first_name,last_name,email,gender,location,locale,work,languages,birthday,relationship_status,hometown,picture').then((data: any) => {
    //     console.log('self data:', data);
    //     let userData: any = {
    //       firstname:  data.firstname,
    //       lastname: data.lastname,
    //       emailaddress1: data.email
    //     }
    //     localStorage.setItem("dpa_portal", JSON.stringify(userData))
    //     this.createContact()
    //   })
    // });
  }

  signOut() {
    var auth2 = gapi.auth2.getAuthInstance();
    auth2.signOut().then(function () {
      console.log('User signed out.');
    });
  }

  async getLineProfile(params: Params) {
    var reqObj: any = {}
    reqObj["grant_type"] = "authorization_code"
    reqObj["code"] = params["code"]
    reqObj["redirect_uri"] = this.util.baseUrl() + "/mainmenu/login"
    reqObj["client_id"] = "1654952386"
    reqObj["client_secret"] = "d129b1c240d16dde27204dadbc5f612c"

    var res: any = await this.apiService.postOther('https://api.line.me/oauth2/v2.1/token', reqObj, "application/x-www-form-urlencoded")

    if (res != null && res["id_token"] != null) {
      var token = res["id_token"];

      let userData = this.parseJwt(token)
      this.cookieData.firstname = userData.name
      this.cookieData.lastname = ""
      this.cookieData.emailaddress1 = userData.email
      this.cookieData.imgUrl = userData.picture

      this.PortalLogin = await this.apiService.getCustomAPI("User", "GetUser", "username=" + userData.email);
      if (this.PortalLogin != null && this.PortalLogin.length > 0) {
        this.cookieData.contactid = this.PortalLogin.customerid
      }
      else {
        this.cookieData.contactid = null
      }

      localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))
      this.router.navigate(["mainmenu"])
    }
  }

  lineLogin() {
    var clientId = "1654952386"
    var redirectUri = this.util.baseUrl() + "/mainmenu/login"
    var state = "1234abcd"
    var scope = "profile%20openid%20email"
    var nonce = "089898zyxzyx"
    window.location.href = "https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=" + clientId + "&redirect_uri=" + redirectUri + "&state=" + state + "&scope=" + scope + "&nonce=" + nonce
  }

  parseJwt(token: string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  async createContact() {
    let contactid = ""

    let req: any = {
      firstname: this.cookieData.firstname,
      lastname: this.cookieData.lastname,
      emailaddress1: this.cookieData.email
    }

    await this.apiService.post("crmservice", "contact", req).then(async (res: any) => {
      if (this.util.isSuccessResponse(res)) {
        if (res.contactid != null && res.contactid != "") {
          contactid = res.contactid
          this.cookieData.contactid = contactid
          localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))

          let reqUser: any = {
            firstname: this.cookieData.firstname,
            lastname: this.cookieData.lastname,
            username: this.cookieData.email
          }
          await this.apiService.postCustomApi("user", "InsertUser", reqUser).then((res: any) => {
            if (this.util.isSuccessResponse(res) && res.code == "200") {
              this.router.navigate(["mainmenu/profile"])
            }
          })
        } else {
          this.util.ErrorDialog("สร้าง Contact ไม่สำเร็จ")
        }
      } else {
        this.util.ErrorDialog("สร้าง Contact ไม่สำเร็จ")
      }
    })
  }

  async goToRegister() {
    this.router.navigate(["mainmenu/register"], { queryParams: { regisType: this.isCompany ? "c" : "n" } })
  }
  async goToForgetPass(type: number) {
    this.router.navigate(["mainmenu/forgotPassword"], { queryParams: { type: type == 1 ? "password" : "username" } })
  }
  async goToForgetUser() {
    this.router.navigate(["mainmenu/forgotUser"])
  }

  fbLibrary() {

    (window as any).fbAsyncInit = function () {
      window['FB'].init({
        appId: '869805000070130',
        cookie: true,
        xfbml: true,
        version: 'v3.0'
      });
      window['FB'].AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js: any, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

  }

  goToIndex() {
    this.router.navigate(["mainmenu/index"])
  }

  ////OTP
  async SubmitOTP() {
    if (this.otp.trim().length > 0) {

      this.util.ShowWaiting(true)

      let reqCheckOtp: any = {
        OTP: this.otp.trim(),
        RefCode: this.otpRef,
        MobileNo: this.telephoneOtp
      }

      let reqCheckOtpRes: any = await this.apiService.postCustomApi("crm", "VerifyOTP", reqCheckOtp)
      if (this.util.isSuccessResponse(reqCheckOtpRes)) {
        if (reqCheckOtpRes.IsValid) {
          this.cookieData = this.dpa_portal
          localStorage.setItem("dpa_portal", JSON.stringify(this.dpa_portal))

          let ticket: any = await this.apiService.get("crmservice", "searchApprovalTicket", "contactid=" + this.cookieData.contactid)
          this.util.ShowWaiting(false)

          /*
          if (ticket != null && ticket.length > 0 && (ticket[0].dpa_approvalstatuscode == "01" || ticket[0].dpa_approvalstatuscode == "02" || ticket[0].dpa_approvalstatuscode == "06")) {
            let url = this.util.baseUrl() + "/mainmenu/statusDocument/" + this.cookieData.contactid
            window.open(url, "_blank")
          }
          */
          this.router.navigate(["mainmenu"])
        }
        else {
          this.util.ShowWaiting(false)
          this.util.WarningDialog("รหัส OTP ที่ท่านกรอกไม่ถูกต้อง")
        }
      }
      else {
        this.util.ShowWaiting(false)
        this.util.WarningDialog("พบข้อผิดพลาดในการยืนยันรหัส OTP กรูณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่")
      }
    }
    else{
      this.util.WarningDialog("กรุณาระบุรหัส OTP")
    }
  }

  cancelOtp() {
    this.showLoginForm = true
    this.showOtp = false
    this.otp = ""
  }

  async requestOtp() {
    this.util.ShowWaiting(true)
    let reqOtp: any = {
      MobileNo: this.telephoneOtp,
    }

    await this.apiService.postCustomApi("crm", "RequestOTP", reqOtp).then(async (reqOtpRes: any) => {
      if (this.util.isSuccessResponse(reqOtpRes)) {

        //reqOtpRes = this.util.AesDecryptDictValue(reqOtpRes.json())
        
        let smsContent = "รหัสตรวจสอบการล็อกอินของคุณคือ : "
        smsContent += reqOtpRes.otpNo + " "
        smsContent += "(RefCode : " +reqOtpRes.RefCode  
        smsContent += " ) (รหัสมีอายุ " + reqOtpRes.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น"  

        let sendSms: any = {
          dpa_description: smsContent,
          dpa_phoneno: this.telephoneOtp
        }
        
        let sendSmsRes: any = await this.apiService.post("crmservice", "sendSms", sendSms)

        this.util.ShowWaiting(false)
        if (this.util.isSuccessResponse(sendSmsRes)) {
          this.otpRef = reqOtpRes.RefCode
          this.otpTimer = 59
          this.lastReqTime = new Date()
          this.requestOtpLblTmp = "ส่งอีกครั้ง"
          this.swithLbl()
          this.disableResentOtp = true
          this.countdown()
          if (reqOtpRes.expInMinute == undefined || reqOtpRes.expInMinute == null) {
            this.TotalTime = 300;
          }
          else {
            this.TotalTime = reqOtpRes.expInMinute * 60;
          }
          this.ElapseTime = 0;
          if (this.SubScr != undefined) {
            this.SubScr.unsubscribe();
          }
          this.SubScr = timer(0, 1000).subscribe(() => this.CountDownOTP());
        }
        else {
          this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่")
        }
      }
      else {
        this.util.ShowWaiting(false)
        this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่")
      }
    })
  }

  countdown() {
    if (this.otpTimer > 0) {

      let dif = new Date().getTime() - this.lastReqTime.getTime();

      var Seconds_from_T1_to_T2 = dif / 1000;
      this.otpTimer = this.totolWaitResend  - Math.round(Seconds_from_T1_to_T2)
      setTimeout(() => {
        this.countdown()
      }, 400);
    }
    else {
      this.disableResentOtp = false
    }
  }

  CountDownOTP() {
    if (this.ElapseTime == 0 && this.TotalTime == 0) {
      this.SubScr.unsubscribe();
      this.OTPCountDown = "";
      return;
    }
    if (this.ElapseTime == this.TotalTime) {
      this.SubScr.unsubscribe();
      this.ElapseTime = 0;
      this.OTPCountDown = "";
      return;
    }

    this.ElapseTime++;
    let RemainingSecs = this.TotalTime - this.ElapseTime;
    let RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
    RemainingSecs = RemainingSecs % 60;
    this.OTPCountDown = " " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs;
  }


  async getContactDROS(idcard: string) { 
    let para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false"
    let tmp: any = await this.apiService.get("crmservice", "contactDros", para)
    return tmp
  }

  getMenuObj(code: string){
    if(this.menuList != null && this.menuList.length > 0) {
      let menuObj: any = this.menuList.filter((m: any) => {
        return m.dpa_code == code
      })
      if(menuObj != null && menuObj.length > 0){
        if(menuObj[0].dpa_isdisplay == 3){
          menuObj[0].show = true
        }
        else if(menuObj[0].dpa_isdisplay == 1 && !this.isCrisis){
          menuObj[0].show = true
        }
        else if(menuObj[0].dpa_isdisplay == 2 && this.isCrisis){
          menuObj[0].show = true
        }
        else{
          menuObj[0].show = false
        }
        
        return menuObj[0]
      }
      else{
        return {}
      }
    }
    else{
      return {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/account/login/login.component.ts